import useSWR from 'swr';
import { EMPTY_OBJ } from '../utils';
import { CACHE_KEY_THREADS_SUMMARY, CACHE_KEY_THREAD_SUMMARY_FN, } from './internal/swrCache';
import useDialectSdk from './useDialectSdk';
const isParamsExtended = (params) => Boolean(params.otherMembers);
const isDataPerThread = (data) => !!(data === null || data === void 0 ? void 0 : data.me);
function useUnreadMessages(params = EMPTY_OBJ) {
    var _a;
    const { refreshInterval } = params;
    const sdk = useDialectSdk(true);
    const { data, mutate } = useSWR(isParamsExtended(params)
        ? CACHE_KEY_THREAD_SUMMARY_FN(params.otherMembers)
        : CACHE_KEY_THREADS_SUMMARY, () => isParamsExtended(params)
        ? sdk === null || sdk === void 0 ? void 0 : sdk.threads.findSummary({
            otherMembers: params.otherMembers,
        })
        : sdk === null || sdk === void 0 ? void 0 : sdk.threads.findSummaryAll(), {
        refreshInterval,
        refreshWhenOffline: true,
    });
    if (isDataPerThread(data)) {
        return {
            hasUnreadMessages: data.me.hasUnreadMessages,
            refresh: mutate,
            unreadCount: data.me.unreadMessagesCount,
        };
    }
    return {
        hasUnreadMessages: !!(data === null || data === void 0 ? void 0 : data.unreadMessagesCount),
        unreadCount: (_a = data === null || data === void 0 ? void 0 : data.unreadMessagesCount) !== null && _a !== void 0 ? _a : 0,
        refresh: mutate,
    };
}
export default useUnreadMessages;
//# sourceMappingURL=useUnreadMessages.js.map